import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./charte.css";
import "./index.css";
import "./ecrans.css";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
